import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentLoadAuditsPage() {
  return <LatamAgentPage locale="es-CO" agentKey="proactive_load_audits" />;
}
